import { Text } from "dash-styled"
import React, { FC } from "react"
import customer11x from "../../../../../../Common/Assets/superai-customer1@1x.png"
import customer12x from "../../../../../../Common/Assets/superai-customer1@2x.png"
import customer21x from "../../../../../../Common/Assets/superai-customer2@1x.png"
import customer22x from "../../../../../../Common/Assets/superai-customer2@2x.png"

export const CustomerReview: FC = () => {
    return (
        <div className="flex flex-col flex-1 justify-center px-10 bg-smoke-970">
            <Review
                className="mb-16"
                index={1}
                review="“A 6x accuracy improvement plus cost saving is really easy to
                sell internally”"
                designation={
                    <>
                        Senior Project Manager,
                        <br /> Certification company
                    </>
                }
                image={`${customer11x} 1x, ${customer12x} 2x`}
            />
            <Review
                index={2}
                review="“Before super.AI we just knew the hype [of AI], now we know the reality”"
                designation={
                    <>
                        Yuluarjo Sentosa, <br />
                        CTO Triputra
                    </>
                }
                image={`${customer21x} 1x, ${customer22x} 2x`}
            />
        </div>
    )
}

interface ReviewProps {
    className?: string
    index: number
    review: string
    designation: React.ReactNode
    image: string
}

const Review: FC<ReviewProps> = ({
    className,
    index,
    review,
    designation,
    image
}) => {
    return (
        <div className={className}>
            <Text size="xl">{review}</Text>
            <div className="flex items-center">
                <img srcSet={image} alt={`customer ${index}`} />
                <Text
                    component="span"
                    className="ml-3 text-rhino-770 whitespace-pre-line"
                >
                    {designation}
                </Text>
            </div>
        </div>
    )
}
